<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header d-block">
                <h1 class="text">{{this.$route.meta.title}}</h1>
            </div>

            <div class="section-body">
                <div class="col-12 text-center mt-3" v-if="loading_page === true">
                    <div class="half-circle-spinner">
                        <div class="circle circle-1"></div>
                        <div class="circle circle-2"></div>
                    </div>
                </div>
                <b-row class="mt-4" v-if="loading_page === false">
                    <!-- <b-col md="4">
                        <b-card no-header class="card-statistic bdr-15">
                            <div class="card-stats">
                                <div class="d-flex align-items-center">
                                    <div class="square">
                                        <img v-if="leaderboard.tier === 'BRONZE'" class="img-ac rounded vert-move" :src="require('@/assets/img/bronze.png')" alt="product">
                                        <img v-if="leaderboard.tier === 'SILVER'" class="img-ac rounded vert-move" :src="require('@/assets/img/silver.png')" alt="product">
                                        <img v-if="leaderboard.tier === 'GOLD'" class="img-ac rounded vert-move" :src="require('@/assets/img/gold.png')" alt="product">
                                        <img v-if="leaderboard.tier === 'DIAMOND'" class="img-ac rounded vert-move" :src="require('@/assets/img/diamond.png')" alt="product">
                                    </div>
                                    <div class="cst-cnt ml-4">
                                        <h4 class="mb-0 text-capitalize">
                                            <template v-if="leaderboard.tier === 'BRONZE'">Bronze</template>
                                            <template v-if="leaderboard.tier === 'SILVER'">Silver</template>
                                            <template v-if="leaderboard.tier === 'GOLD'">Gold</template>
                                            <template v-if="leaderboard.tier === 'DIAMOND'">Diamond</template>
                                            Tier
                                        </h4>
                                        <p class="mb-0">Total {{leaderboard.events_count}} Event</p>
                                    </div>
                                </div>

                                <div class="profile-widget-description border-top pt-3">
                                    <div class="mb-3"><strong> Description</strong></div>
                                    <div>
                                        <template v-if="leaderboard.tier === 'BRONZE'">
                                            Dengan Tier Bronze anda bisa mendapatkan klaim bonus sebesar sejumlah Rp 50.000 selama 3 kali saat jumlah event publish anda mencapai jumlah 10,20,30,40. 
                                        </template>
                                        <template v-if="leaderboard.tier === 'SILVER'">
                                            Dengan Tier Silver anda bisa mendapatkan klaim bonus sebesar sejumlah Rp 100.000 selama 3 kali saat jumlah event publish anda mencapai jumlah 50,70,90. 
                                        </template>
                                        <template v-if="leaderboard.tier === 'GOLD'">
                                            Dengan Tier Silver anda bisa mendapatkan klaim bonus sebesar sejumlah Rp 250.000 selama 3 kali saat jumlah event publish anda mencapai jumlah 100,150,200. 
                                        </template>
                                        <template v-if="leaderboard.tier === 'DIAMOND'">
                                            Dengan Tier Diamond anda bisa mendapatkan klaim bonus sebesar sejumlah Rp 500.000 selama 3 kali saat jumlah event publish anda mencapai jumlah 300,400,500. 
                                        </template>
                                    </div>
                                </div>
                                <button class="btn btn-primary mt-3 mb-3" v-b-modal.modal-Bonus> Detail Bonus <template v-if="leaderboard.claim">( 1 Bonus Detected )</template></button>

                            </div>
                        </b-card>
                    </b-col> -->
                    <b-col md="12">
                        <b-card no-header class="card-statistic bdr-15">
                            <div class="card-header">
                                <h4>Top 6 Leaderboard Agent</h4>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-2 col-3 text-center" v-for="data in leaderboard.top_agent" :key="data.id">
                                        <div class="mb-3">
                                            <img alt="image" v-if="data.photo" :src="data.photo" class="tl-pp rounded-circle">
                                            <img alt="image" v-if="!data.photo" src="@/assets/img/user.png" class="tl-pp rounded-circle">
                                        </div>
                                        <div class="mt-2 font-weight-bold">{{data.name}}</div>
                                        <div class="text-muted text-small">{{data.tier}}</div>
                                    </div>
                                </div>
                            </div>
                        </b-card>
                    </b-col>
                    <b-col md="7">
                        <b-card no-header class="card-statistic bdr-15">
                            <div class="card-header">
                                <h4>Your Challenge</h4>
                            </div>
                            <div class="card-body">
                                <div class="summary">
                                    <div class="summary-item">
                                        <ul class="list-unstyled list-unstyled-border">
                                            <li class="media"  v-for="(data) in leaderboard.challenges" :key="data.id" :class="data.challenge.status === 'DONE' ? 'd-none' : ''">
                                                <div class="media-body">
                                                    <div class="media-right">
                                                        <button class="btn btn-warning mr-2" v-b-modal.modal-Detail @click="detailChallenge(data)">Detail</button>
                                                        <button class="btn btn-primary" v-b-modal.modal-DetailChallenge @click="detailChallenge(data)">Leaderboard</button>
                                                    </div>
                                                    <div class="media-title" v-b-modal.modal-Detail><a href="#" @click.prevent="detailChallenge(data)">{{data.challenge.name}}</a></div>
                                                    <div class="text-muted text-small">Challenge Periode {{data.challenge.start_date | formatDate}} - {{data.challenge.end_date | formatDate}}</div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </b-card>
                    </b-col>
                    <b-col md="5">
                        <b-card no-header class="card-statistic bdr-15">
                            <div class="card-header">
                                <h4>Your Challenge Achievement</h4>
                            </div>
                            <div class="card-body">
                                <div class="summary">
                                    <div class="summary-item">
                                        <ul class="list-unstyled list-unstyled-border">
                                            <li class="media align-items-center" v-for="(data) in leaderboard.achievements" :key="data.id" :class="data.achievement ? '' : 'd-none'">
                                                <template v-if="data.achievement">
                                                    <a href="#">
                                                        <img v-if="data.achievement.rank === 1" class="vert-move img-ac mr-3 rounded" :src="require('@/assets/img/gold-medal.png')" alt="product">
                                                        <img v-if="data.achievement.rank === 2" class="vert-move img-ac mr-3 rounded" :src="require('@/assets/img/silver-medal.png')" alt="product">
                                                        <img v-if="data.achievement.rank >= 3" class="vert-move img-ac mr-3 rounded" :src="require('@/assets/img/bronze-medal.png')" alt="product">
                                                    </a>
                                                    <div class="media-body ml-3">
                                                        <label v-if="Date.parse(data.achievement.created_at) > Date.now() - (35 * 1000 * 60 * 60 * 24)" class="badge badge-primary">New</label>
                                                        <div class="media-title"><a href="#" v-b-modal.modal-Detail @click.prevent="detailChallenge(data)">{{data.achievement.name}}</a></div>
                                                        <div class="text-muted text-small">Challenge Periode {{data.challenge.start_date | formatDate}} - {{data.challenge.end_date | formatDate}}</div>
                                                    </div>
                                                </template>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </section>


        <b-modal id="modal-DetailChallenge" @show="_getParticipantRank()" size="xl" class="modal-form" title="Winner List" centered hide-footer>
            
            <b-row class="mb-4 border-bottom pb-4" v-if="detail_challenge.hasOwnProperty('challenge')">
                <b-col md="7">
                    <div class="pb-1"><strong>Name :</strong> {{detail_challenge.challenge.name}}</div>
                    <div class="pb-1"><strong>Start Date :</strong> {{detail_challenge.challenge.start_date | formatDate}}</div>
                    <div class="pt-1"><strong>End Date :</strong> {{detail_challenge.challenge.end_date | formatDate}}</div>
                </b-col>
            </b-row>
            
            <div class="row" v-if="detail_challenge.challenge">
                <div class="col-md-2 col-3 text-center" v-for="(data,index) in participant_rank" :key="data.id" :class="index < detail_challenge.challenge.achievement.length ? '' : 'd-none'">
                    <div class="mb-3">
                        <img alt="image" v-if="data.photo" :src="data.photo" class="tl-pp rounded-circle">
                        <img alt="image" v-if="!data.photo" src="@/assets/img/user.png" class="tl-pp rounded-circle">
                    </div>
                    <div class="mt-2 font-weight-bold">{{data.name}}</div>
                    <div class="text-muted text-small">Rank {{index + 1}}</div>
                </div>
            </div>


        </b-modal>

        <b-modal id="modal-Bonus" size="lg" @show="_getBonusAgent()" class="modal-form" title="Claim Bonus" centered hide-footer>
            <div class="row row-bonus">
                <div class="col-3 position-relative" v-for="data in tier" :key="data" @click.prevent="bonus_tier_active = data">
                    <div class="bonus-wrap text-center pointer">
                        <div class="img-bonus" :class="leaderboard.tier === data
                        || leaderboard.tier === 'SILVER' && data === 'BRONZE'
                        || leaderboard.tier === 'GOLD' && data === 'BRONZE' 
                        || leaderboard.tier === 'GOLD' && data === 'SILVER' 
                        || leaderboard.tier === 'DIAMOND' && data === 'BRONZE' 
                        || leaderboard.tier === 'DIAMOND' && data === 'SILVER' 
                        || leaderboard.tier === 'DIAMOND' && data === 'GOLD' 
                        ? '' : 'lock'">
                            <img v-if="data === 'BRONZE'" class="vert-move img-ac rounded" :src="require('@/assets/img/bronze.png')" alt="product">
                            <img v-if="data === 'SILVER'" class="vert-move img-ac rounded" :src="require('@/assets/img/silver.png')" alt="product">
                            <img v-if="data === 'GOLD'" class="vert-move img-ac rounded" :src="require('@/assets/img/gold.png')" alt="product">
                            <img v-if="data === 'DIAMOND'" class="vert-move img-ac rounded" :src="require('@/assets/img/diamond.png')" alt="product">
                        </div>
                        <div class="text-center">{{data}}</div>
                        <div><i class="uil uil-angle-down"></i></div>
                    </div>
                </div>
            </div>

            <div class="half-circle-spinner mt-5 mb-5" v-if="loading_bonus === true">
                <div class="circle circle-1"></div>
                <div class="circle circle-2"></div>
            </div>

            <template v-if="loading_bonus === false && bonus_agent.length !== 0">
                <div class="mt-4 border-top pt-3">
                    <h5 class="text-uppercase">Bonus Tier {{bonus_tier_active ? bonus_tier_active : leaderboard.tier}}</h5>
                </div>
                <div class="table-responsive bdr-15 mt-3">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Event Total</th>
                                <th>Reward</th>
                                <th>Claim Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(data,index) in bonus_agent" :key="data.id" v-show="bonus_tier_active === null && leaderboard.tier === data.tier || bonus_tier_active === data.tier">
                                <td>
                                    <label style="width:80px;" disabled v-if="data.claim.length !== 0 && data.claim[0].status === 'CLAIMED'" class="badge badge-success">CLAIMED</label>
                                    <label style="width:80px;" disabled v-if="data.claim.length === 0 && leaderboard.events_count >= $options.filters.countIndex(index,bonus_agent)" class="badge badge-secondary">LOST</label>
                                    <a target="_blank" v-if="data.claim.length === 0 && leaderboard.events_count >= data.slot && leaderboard.events_count <= $options.filters.countIndex(index,bonus_agent)" :href="'https://wa.me/6281337589348?text=Halo, saya mau claim bonus ' + data.slot + ' Undangan'" class="btn btn-info">CLAIM NOW</a>
                                    <button disabled v-if="data.claim.length === 0 && leaderboard.events_count <= data.slot" class="btn btn-disabled">add {{data.slot - leaderboard.events_count}} events to claim</button>
                                </td>
                                <td>
                                {{data.slot}} Events
                                </td>
                                <td>{{data.bonus | formatRupiah}}</td>
                                <td>
                                    <template v-if="data.claim.length === 0">-</template>
                                    <template v-if="data.claim.length !== 0">{{data.claim[0].claim_date | formatDate}}</template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </b-modal>

        <b-modal id="modal-Detail" size="xl" @show="_getParticipantRank()" @hide="show_detail_challenge = 'Description'" class="modal-form" title="Detail Challenge" centered hide-footer>
            
            <b-row class="mb-4 border-bottom pb-4" v-if="detail_challenge.hasOwnProperty('challenge')">
                <b-col md="7">
                    <div class="pb-1"><strong>Name :</strong> {{detail_challenge.challenge.name}}</div>
                    <div class="pb-1"><strong>Start Date :</strong> {{detail_challenge.challenge.start_date | formatDate}}</div>
                    <div class="pt-1"><strong>End Date :</strong> {{detail_challenge.challenge.end_date | formatDate}}</div>
                </b-col>
            </b-row>
            
            <div class="menu mb-4">
                <button class="btn mr-2" v-for="(data,index) in menu_detail_challenge"
                        :key="index" :class="data === show_detail_challenge ? 'btn-primary' : 'btn-outline-primary'"
                        @click.prevent="show_detail_challenge = data"
                        >
                        {{data}}
                    </button>
            </div>
            <div class="d-flex align-items-center mb-3" v-if="detail_challenge.hasOwnProperty('challenge')">
                <div>
                    <h5 class="mb-0">{{show_detail_challenge}}</h5>
                </div>
            </div>
            
            <template v-if="show_detail_challenge === 'Description'">
                <div v-if="detail_challenge.hasOwnProperty('challenge')" v-html="detail_challenge.challenge.desc"></div>
            </template>
            <template v-if="show_detail_challenge === 'Participant'">
                <div class="table-responsive bdr-15" v-if="detail_challenge.hasOwnProperty('challenge')">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>User</th>
                                <th>Event Total</th>
                                <th>Ranking</th>
                            </tr>
                        </thead>
                        <tbody v-if="loading_participant === false">
                            <tr class="tr-ac" v-for="(data,index) in participant_rank" :key="data.id">
                                <td>
                                    <div>{{data.name}}</div>
                                    <small>{{data.email}}</small>
                                </td>
                                <td>
                                    {{data.events_count}}
                                </td>
                                <td>
                                    {{parseInt(index) + 1}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="half-circle-spinner" v-if="loading_participant === true">
                        <div class="circle circle-1"></div>
                        <div class="circle circle-2"></div>
                    </div>
                </div>
            </template>
            <template v-if="show_detail_challenge === 'Achievement'">
                <div class="table-responsive bdr-15 mb-4" v-if="detail_challenge.hasOwnProperty('challenge')">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Rank</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="tr-ac" v-for="data in detail_challenge.challenge.achievement" :key="data.id">
                                <td>
                                    {{data.name}}
                                </td>
                                <th>
                                    {{data.rank}}
                                </th>
                            </tr>
                        </tbody>
                    </table>
                </div>
    
            </template>

        </b-modal>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex'
    import moment from 'moment'

    export default {
        data() {
            return {
                loading_page:false,
                loading_participant:false,
                loading_bonus:false,
                detail_challenge:{},
                show_detail_challenge:'Description',
                menu_detail_challenge:['Description','Participant','Achievement'],

                tier:['BRONZE','SILVER','GOLD','DIAMOND'],
                bonus_tier_active:null,
            }
        },
        mounted(){
            this._getLeaderboardAgent()
        },
        components: {
        },
        computed:{
            ...mapState('DashboardControl', {
                reports: state => state.reports,
                leaderboard: state => state.leaderboard,
                participant_rank: state => state.participant_rank,
            }),
            ...mapState('BonusControl', {
                bonus_agent: state => state.bonus_agent,
            }),
        },
        filters: {
            countIndex:function(val,bonus_agent){
                let index = val + 1
                index = parseInt(index)
                if(index > bonus_agent.length - 1){
                    return 500
                }else{
                    return bonus_agent[index].slot
                }
            },
            formatDate: function(val){
                return moment(String(val)).format('DD MMMM YYYY')
            },
            formatRupiah:function(val){
                if(val){
                    let value = (parseInt(val)/1).toFixed(0).replace('.', ',')
                    return "Rp " + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                }else{
                    return '-'
                }
            }
        },
        methods:{
            ...mapActions('DashboardControl', ['getReportsAgent','getLeaderboardAgent','getParticipantRank']),
            ...mapActions('BonusControl', ['getBonusAgent']),
            
            _getBonusAgent:function(){
                this.loading_bonus = true
                this.getBonusAgent().then(() => {
                    this.loading_bonus = false
                }).catch((error) => {
                    console.log(error)
                    this.loading_bonus = false
                })
            },

            _getLeaderboardAgent: function(){
                this.loading_page = true
                this.getLeaderboardAgent().then(() => {
                    this.loading_page = false
                }).catch((error) => {
                    console.log(error)
                    this.loading_page = false
                })
            },
            detailChallenge:function(data){
                this.detail_challenge = data
            },
            _getParticipantRank:function(){
                this.loading_participant = true
                this.getParticipantRank({id:this.detail_challenge.challenge.id,start_date:this.detail_challenge.challenge.start_date,end_date:this.detail_challenge.challenge.end_date}).then(() => {
                    this.loading_participant = false
                }).catch((error) => {
                    console.log(error)
                    this.loading_participant = false
                })
            },
        },
    }
</script>

<style scoped>

    .img-bonus img{
        width: 80px !important;
        height: 80px !important;
    }
    .bonus-wrap{
        background: #f7f7f7;
        width: 150px;
        margin: 0 auto;
        border-radius: 20px;
        padding: 15px 0px;
    }
    .bonus-wrap .lock .vert-move{
        -webkit-animation:none;
        animation: none;
    }
    .bonus-wrap .lock img{
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%);
    }
    .bonus-wrap i{
        font-size: 30px;
    }

    @media (max-width: 768px){
        .bonus-wrap{
            width: auto;
        }
        .img-bonus img{
            width: 44px !important;
            height: 44px !important;
        }
        .row-bonus .col-3{
            padding: 0px 3px !important;
        }
    }

    

</style>
